import CopyMaker from "lib/Copymaker/Copymaker";
const sessionRecorder = {};

const apiKey = process.env.REACT_APP_SESSION_REWIND_KEY;
const userApplication = process.env.REACT_APP_SESSION_REWIND_APP;

const cmConfig = { apiKey, iframe: true };
const easilConfig = {
  apiKey,
  startRecording: true,
  userInfo: { userApplication }
};

/**
 * Get the hostname of the current page, handling iframe scenarios.
 *
 * When the application runs in an iframe (e.g., CopyMaker mode or portal embedding),
 * we need to check the parent window's hostname to determine the environment.
 *
 * @returns {string} The hostname - parent hostname if in iframe, current hostname otherwise
 */
function getHostname() {
  try {
    // If in iframe, use parent hostname to determine environment
    // This is important because the editor might be embedded on app.easil.com
    if (window.location !== window.parent.location) {
      return window.parent.location.hostname;
    }
  } catch (e) {
    // Cross-origin iframe throws SecurityError when accessing parent.location
    // Fallback to current window hostname in this case
  }
  return window.location.hostname;
}

/**
 * Check if the application is running in the production environment.
 *
 * Both conditions must be true:
 * 1. Build-time check: NODE_ENV === 'production' (production build)
 * 2. Runtime check: hostname === 'app.easil.com' (deployed to production URL)
 *
 * This prevents SessionRewind from loading in:
 * - Local development (localhost)
 * - Dev environment (dev.easil.com)
 * - PR preview environments (pr*.easil.com)
 * - Production builds running on non-production domains
 *
 * @returns {boolean} true if running in production environment
 */
function isProductionEnvironment() {
  return (
    process.env.NODE_ENV === "production" && getHostname() === "app.easil.com"
  );
}

sessionRecorder.init = () => {
  // Only initialize SessionRewind in production environment
  if (!isProductionEnvironment()) {
    return;
  }

  window.SessionRewindConfig = CopyMaker.isCmModeOn() ? cmConfig : easilConfig;
  const f = document.createElement("script");
  f.async = 1;
  f.crossOrigin = "anonymous";
  f.src = "https://rec.sessionrewind.com/srloader.js";
  const g = document.getElementsByTagName("head")[0];
  g.insertBefore(f, g.firstChild);
};

sessionRecorder.identify = data => {
  // Don't attempt to identify if SessionRewind is not initialized (non-production)
  if (!isProductionEnvironment()) {
    return;
  }

  if (CopyMaker.isCmModeOn()) {
    return;
  }
  const { country, email, id, name, roles, teamId, teamPlan } = data;
  const userInfo = {
    userId: email, // NOTE: portal is identifying session by user email
    id,
    userName: name,
    email,
    roles: `${roles}`,
    teamId,
    teamPlan,
    country,
    userApplication
  };
  if (window.sessionRewind) {
    window.sessionRewind.identifyUser(userInfo);
  } else {
    window.SessionRewindConfig = {
      apiKey,
      startRecording: true,
      userInfo
    };
  }
};

export default sessionRecorder;
